import { render, staticRenderFns } from "./TeacherViewTabInformation.vue?vue&type=template&id=53de44b7&"
import script from "./TeacherViewTabInformation.vue?vue&type=script&lang=js&"
export * from "./TeacherViewTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./TeacherViewTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports